function Label(props: { text: string }) {
    return (
        <div className="rounded-full px-3 py-0.5 bg-blue-100 flex items-center">
            <p className="text-xs text-blue-800">{props.text}</p>
        </div>
    )
}

export default Label;